export class Modificacion_sueldo_dep{
    constructor(
        public id: String,
        public valor: Number,
        public tipo: String,
        public indice: Number,
        public tipo_sueldo: String

    ){}
}